import * as React from 'react';
import { Link } from 'react-router-dom';
import { ProcesHandlerHelpers } from '../containers/helpers/ProcesHandlerHelpers';

export interface AlertProps {
  title: string;
  type: string;
  link: string;
  linkText : string;
}

function getAlertClassName(type: string) {
  
  let alertClassName : string = "content__callout-yellow";
  
  if (type == "warning" || type == "form-error-block") {
    alertClassName = "content__callout-yellow";
  }

  if (type == "information") {
    alertClassName = "content__callout-blue";
  }

  if (type == "error") {
    alertClassName = "content__callout-error";
  }

  if (type == "succes") {
    alertClassName = "content__callout-succes";
  }

  return alertClassName + " " + (type == "form-error-block" ? "content__callout-form-error" : "");
}

function getAlertIcon(type: string) {
  if (type == "succes") {
    return "icon icon-success--inversed";
  }
  return "icon " + (type == "warning" || type == "form-error-block" ? "icon-warning--inversed" : "icon-info--inversed");
}

function getAlertLink(link: string, linkText: string) {
  if (!link || !linkText) {
    return <></>;
  }

  return <>
    {link  && linkText && link.indexOf("http") == 0 ? 
      <a className="content__callout-link" target="_blank" href={link}><span>{linkText}</span>
        <span className="icon icon-open-chevron-right"></span>
      </a> :
      <Link className="content__callout-link" to={link}><span>{linkText}</span>
        <span className="icon icon-open-chevron-right"></span>
      </Link>}
  </>;
}

export const AlertMessage = (props: AlertProps) => <div className="alerts-container container">
    <div className={"row content__callout " + getAlertClassName(props.type)            
      }>
      <div className={"col-auto content__callout-icon-container content__callout-tip " }>
        <span className={getAlertIcon(props.type)} />
      </div>
      <div className="col content__callout-content">
        <div className="content__callout-message">{props.title}</div>
        {getAlertLink(props.link, props.linkText)}
      </div>
    </div>
  </div>;